// extracted by mini-css-extract-plugin
module.exports = {"container":"_404-module--container--31plR","image":"_404-module--image--276n_","text":"_404-module--text--2vScR"};